export default __webpack_public_path__ + "static/media/pdamgr-hover.0a11b805.svg";